// extracted by css-extract-rspack-plugin
export default {"disablePointer":"CardInput__disablePointer--U6TEj","cardInfo":"CardInput__cardInfo--ATBwA"};